<div class="main-container">
  <div class="login-container">
    <div class="left-container"></div>
    <div class="right-container"></div>
    <div class="sign-container">
      <div class="sign-left-container">

        <div *ngIf="!Custtoggle" [hidden]="showClientOtp" class="demoRetailer">
          <button mat-flat-button style="color: #8692A6;" (click)="onCustomerClick()">
            <span style = "font-family: 'Poppins';">< Back</span>
          </button>
          <div class="signUpHeader pt-2 pb-3 flex-grow-1 hidden-scroll">

            <!-- <div class="alert alert-warning border-2 d-flex align-items-center"
              *ngIf="showAlert" role="alert">
            <div class="bg-warning me-3 icon-item"><span
                    class="fas fa-exclamation-circle text-white fs-3"></span></div>
            <p class="mb-0 flex-1" style = "font-family: 'Poppins';">{{ errorMesage || 'Something went wrong please try again later !!!!'}}</p>
            <button class="btn-close" type="button" data-bs-dismiss="alert"
                aria-label="Close"></button>
            </div>
            <h1 style="font-weight: 500;margin: -13px 0 -2px;"><b class = "mb-1"  style = "font-size:20px;font-weight:500;font-family: 'Poppins';">Sign Up As a Retailer!</b></h1> -->
            <!-- <div class="toggle-text col-auto fs-0 mb-2 text-900"><span class="mb-0 undefined"  style = "font-family: 'Poppins';">
                    Already have an Acccount? </span>
                    <span><a style="color: #FC7643;"
                        (click)="onCustomerClick()"><u><b  style = "font-family: 'Poppins';"> LOGIN!</b></u></a></span>
                        <hr class="top-line my-2" style="opacity: 20%;">
            </div> -->

            <form [formGroup]="registerForm" (ngSubmit)="clientRegister()">

                <div class="mb-3 col-sm-12">
                    <label class="form-label" for="card-firstname"  style = "font-family: 'Poppins';">Full Name <span class="error-asterisk">*</span></label>
                    <input class="form-control" maxLength="50" placeholder="Full Name" autofocus
                        formControlName="firstName" type="text" [ngClass]="{
                          'is-invalid': f.firstName.invalid && submitted
                        }" autocomplete="new-password" id="card-firstname" required />
                    <div style="margin-bottom: -10px;"
                        *ngIf="f.firstName.invalid && submitted"
                        class="invalid-feedback">
                        <div *ngIf="f.firstName.errors.required"  style = "font-family: 'Poppins';">
                            Full Name is required.
                        </div>
                        <div *ngIf="f.firstName.errors.pattern"  style = "font-family: 'Poppins';">
                            Only characters allowed.
                        </div>
                    </div>
                </div>

                <div class="mb-3 col-sm-12">
                    <label class="form-label" for="card-email"  style = "font-family: 'Poppins';">Email Address <span class="error-asterisk">*</span></label>
                    <input class="form-control" formControlName="email" type="text" placeholder="Email Address"
                        [ngClass]="{
                          'is-invalid': f.email.invalid && submitted
                        }" autocomplete="new-password" required id="card-email" />
                    <div style="margin-bottom: -10px;"
                        *ngIf="submitted && f.email.invalid" class="invalid-feedback">
                        <div *ngIf="f.email.errors.required"  style = "font-family: 'Poppins';">
                            Email is required
                        </div>
                        <div *ngIf="f.email.errors.pattern"  style = "font-family: 'Poppins';">
                            Email must be a valid Email address
                        </div>
                    </div>
                </div>

                <div class="row gx-2">
                    <label class="form-label" for="card-mobile"  style = "font-family: 'Poppins';">Contact # <span class="error-asterisk">*</span></label>
                    <div class="mb-3 col-sm-3">
                        <mat-form-field class="example-full-width" app>
                            <input type="text" class="form-control mod" (change)="getCountryByname($event)" aria-label="Assignee" matInput
                                formControlName="countryId" [matAutocomplete]="auto"
                                [ngClass]="{
                                  'is-invalid': f.countryId.invalid && submitted
                                }" readonly>
                            <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
                                <mat-option *ngFor="let option of filteredOptions | async" (onSelectionChange)="setCountryId(option)"
                                    [value]="option.countryNumber" matTooltip="{{ option.countryName }} {{option.countryNumber}}">
                                    {{option.countryName}}
                                    {{option.countryNumber}}
                                </mat-option>
                            </mat-autocomplete>
                            <div style="margin-bottom: -10px;" *ngIf="f.countryId.invalid && submitted" class="invalid-feedback mb-2">
                                <div *ngIf="f.countryId.errors.required"  style = "font-family: 'Poppins';">
                                    Country name is required.
                                </div>
                            </div>
                        </mat-form-field>
                    </div>

                    <div class="mb-3 col-sm-9">

                        <input class="form-control intl-tel-input" formControlName="mobile" type="tel" placeholder="Contact #"
                            (keypress)="numberOnly($event)" minlength="10" maxlength="10"
                            [ngClass]="{ 'is-invalid': f.mobile.invalid && submitted }" autocomplete="new-password" id="card-mobile" required/>
                        <div style="margin-bottom: -10px;" *ngIf="f.mobile.invalid && submitted" class="invalid-feedback">
                            <div *ngIf="f.mobile.errors.required">
                                Contact # is required.
                            </div>

                            <div *ngIf="f.mobile.errors.minlength">
                                Contact # must be of 10-digits.
                            </div>
                            <div *ngIf="f.mobile.errors.maxlength">
                                Contact # must be of 10-digits.
                            </div>
                            <div *ngIf="f.mobile.errors.pattern">
                                Only Digits
                            </div>

                        </div>
                    </div>

                </div>

                <div class="mb-3 col-sm-12">
                    <label for="industryType" class="form-label">Industry Type <span class="error-asterisk">*</span></label>
                    <select class="form-select form-control" id="industryType" formControlName="industryType" name="industryType"
                    [ngClass]="{ 'is-invalid': f.industryType.invalid && submitted }" required>
                        <option value="Retail">Retail</option>
                        <option value="Supermarket">Supermarket</option>
                        <option value="Transporting">Transporting</option>
                        <option value="Spare Parts">Spare Parts</option>
                        <option value="Manufacturing">Manufacturing</option>
                    </select>
                    <div style="margin-bottom: -10px;" *ngIf="f.industryType.invalid && submitted" class="invalid-feedback">
                        <div *ngIf="f.industryType.errors.required && submitted" style = "font-family: 'Poppins';">
                            Industry type is required
                        </div>
                    </div>
                </div>

                <div class="mb-3  col-sm-12">
                    <label class="form-label" for="card-password"  style = "font-family: 'Poppins';">Create Password <span class="error-asterisk">*</span></label>
                    <input class="form-control mod" type="password"
                        [type]="hide ? 'password' : 'text'" formControlName="password"
                        id="card-password"
                        [ngClass]="{ 'is-invalid': f.password.invalid && submitted }"
                        required autocomplete="new-password" />
                    <span class="form-control-feedback" (click)="toggleShow()">
                        <i class="p-1"
                            [ngClass]="hide ? 'fa fa-eye-slash':'fa fa-eye'"></i>
                    </span>
                    <div style="margin-bottom: -10px;"
                        *ngIf="f.password.invalid && submitted"
                        class="invalid-feedback">
                        <div *ngIf="f.password.errors.required"  style = "font-family: 'Poppins';">
                            Password is required.
                        </div>
                    </div>

                </div>

                <div class="form-check my-2">
                    <input class="form-check-input" type="checkbox"
                        id="card-register-checkbox" formControlName="acceptTerms" [ngClass]="{
                        'is-invalid': f.acceptTerms.invalid && submitted
                        }" required />
                    <label class="form-label" for="card-register-checkbox"  style = "font-family: 'Poppins';">I agree to
                        <a routerLink="/auth/term-and-condition"><u  style = "font-family: 'Poppins';"> Terms & Condition
                            </u></a> </label>
                    <div style="margin-bottom: -13px;"
                        *ngIf="submitted && f.acceptTerms.errors" class="invalid-feedback"  style = "font-family: 'Poppins';">
                        Accept Ts & Cs is required
                    </div>
                </div>

                <div class="mb-1">
                    <button  class="login-btn d-block w-100 mt-3" type="submit" name="submit">
                      <span  style = "font-family: 'Poppins';">Register</span>
                    </button>
                </div>

            </form>

          </div>
        </div>

        <div *ngIf="Custtoggle" [hidden]="showCustomerOtp" class="demo">
            <button mat-flat-button style="color: #8692A6;" (click)="onRetailerClick()">
                <span  style = "font-family: 'Poppins';">< Back</span>
              </button>

            <div class="p-4 p-md-5 flex-grow-1">
                <div class="alert alert-warning border-2 d-flex align-items-center"
                    *ngIf="showAlert" role="alert">
                    <div class="bg-warning me-3 icon-item"><span
                            class="fas fa-exclamation-circle text-white fs-3"></span></div>
                    <p class="mb-0 flex-1"  style = "font-family: 'Poppins';">User Exists Already!!!!</p>
                    <button class="btn-close" type="button" data-bs-dismiss="alert"
                        aria-label="Close"></button>
                </div>
                <h1 style="font-weight: 500;color: #000000;font-family: 'Poppins';font-size:20px;">Sign Up As a Customer!</h1>
                <div class="toggle-text col-auto fs-0 my-3 text-900">
                    <span class="mb-0 undefined"  style = "font-family: 'Poppins';">
                        Already have an account?
                    </span>
                    <span><a style="color: #FC7643;" (click)="onRetailerClick()">
                        <b  style = "font-family: 'Poppins';">LOGIN!</b></a>
                        </span>
                        <hr class="top-line my-2" style="opacity: 20%;">
                </div>
                <form [formGroup]="customerRegisterForm" (ngSubmit)="customerRegister()">

                    <div class="mb-3 col-sm-12">
                        <label class="form-label" for="card-firstname"  style = "font-family: 'Poppins';">Full Name</label>
                        <input class="form-control" maxLength="50" placeholder="Full name"
                            formControlName="firstName" type="text" [ngClass]="{
                            'is-invalid': c.firstName.invalid && submitted
                            }" autocomplete="new-password" id="card-firstname" required />
                        <div *ngIf="c.firstName.invalid && submitted"
                            class="invalid-feedback">
                            <div *ngIf="c.firstName.errors.required"  style = "font-family: 'Poppins';">
                                Full Name is required.
                            </div>
                            <div *ngIf="c.firstName.errors.pattern"  style = "font-family: 'Poppins';">
                                Only characters allowed.
                            </div>
                        </div>
                    </div>

                    <div class="row gx-2">
                        <label class="form-label" for="card-mobile"  style = "font-family: 'Poppins';">Contact #</label>
                        <div class="mb-3 col-sm-3">
                            <mat-form-field class="example-full-width" app>
                                <input type="text" class="form-control mod" (change)="getCountryByname($event)" aria-label="Assignee" matInput
                                    formControlName="countryId" [matAutocomplete]="auto" [ngClass]="{
                                                                                                'is-invalid': f.countryId.invalid && submitted
                                                                                                }" readOnly>
                                <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
                                    <mat-option *ngFor="let option of filteredOptions | async" (onSelectionChange)="setCountryId(option)"
                                        [value]="option.countryName" matTooltip="{{ option.countryName }} {{option.countryNumber}}">
                                        {{option.countryName}} {{option.countryNumber}}
                                    </mat-option>
                                </mat-autocomplete>
                                <div style="margin-bottom: -10px;" *ngIf="f.countryId.invalid && submitted" class="invalid-feedback mb-2">
                                    <div *ngIf="f.countryId.errors.required"  style = "font-family: 'Poppins';">
                                        Country name is required.
                                    </div>
                                </div>
                            </mat-form-field>
                        </div>

                        <div class="mb-3 col-sm-9">

                            <input class="form-control intl-tel-input" formControlName="mobile" type="tel" placeholder="Contact #"
                                (keypress)="numberOnly($event)" minlength="10" maxlength="10"
                                [ngClass]="{ 'is-invalid': c.mobile.invalid && submitted }" autocomplete="new-password" id="card-mobile" required/>
                            <div style="margin-bottom: -10px;" *ngIf="c.mobile.invalid && submitted" class="invalid-feedback">
                                <div *ngIf="c.mobile.errors.required">
                                    Contact # is required.
                                </div>
    
                                <div *ngIf="c.mobile.errors.minlength">
                                    Contact # must be of 10-digits.
                                </div>
                                <div *ngIf="c.mobile.errors.maxlength">
                                    Contact # must be of 10-digits.
                                </div>
                                <div *ngIf="c.mobile.errors.pattern">
                                    Only Digits
                                </div>
    
                            </div>
                        </div>

                    </div>

                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" (keyup.enter)="customerRegister()"
                            id="card-register-checkbox" formControlName="acceptTerms" [ngClass]="{
                        'is-invalid': c.acceptTerms.invalid && submitted
                        }" required />
                        <label class="form-label" for="card-register-checkbox"  style = "font-family: 'Poppins';">I agree to
                            <a routerLink="/auth/term-and-condition"><u  style = "font-family: 'Poppins';"> Terms & Condition
                                </u></a>
                        </label>
                        <div *ngIf="submitted && c.acceptTerms.errors" class="invalid-feedback"  style = "font-family: 'Poppins';">
                            Accept Ts & Cs is required
                        </div>
                    </div>
                    
                    <div class="mb-1">
                        <button class="login-btn d-block w-100 mt-0" type="submit"
                            name="submit">
                            <span  style = "font-family: 'Poppins';">Register</span>
                        </button>
                    </div>
                </form>

            </div>
        </div>

        <div [hidden]="!showClientOtp" class = "demo">
            <div class="p-4 p-md-5 flex-grow-1">
                <div class="alert alert-success mb-5" *ngIf="successful" role="alert"  style = "font-family: 'Poppins';">OTP Has
                    Sent Successfully To Your Email-ID And Contact #</div>
                <h3  style = "font-family: 'Poppins';">Verify as {{ userName }}</h3>
                <form [formGroup]="otpClientData" (ngSubmit)="verifyClientOtp()">

                    <div class="row gx-2">
                        <div class="mb-3 col-sm-12">
                            <label class="form-label" for="card-email"  style = "font-family: 'Poppins';">Enter Email OTP</label>
                            <input class="form-control" (keypress)="numberOnly($event)"
                                formControlName="emailotp" type="password" id="card-email-otp" />
                        </div>
                    </div>
                    <div class="row flex-between-center">
                        <div class="col-auto"></div>
                        <div class="col-auto text-center">
                            <button class="btn btn-link fs--2" (click)="clientResendOtp()"
                                type="button" [disabled]="messageSuccess" style="border: none;">
                                <span  style = "font-family: 'Poppins';font-size: 10px;">Resend OTP</span>
                            </button>
                        </div>
                    </div>
                    <div class="mb-3">
                        <button class="btn login-btn d-block w-100 mt-3" type="submit"
                            name="submit" style="height:40px;">
                            <span  style = "font-family: 'Poppins';">Verify</span>
                        </button>

                    </div>
                </form>

            </div>
        </div>

        <div [hidden]="!showCustomerOtp" class = "demo">
            <div class="p-4 p-md-5 flex-grow-1">
                <div class="alert alert-success mb-5" *ngIf="successful" role="alert"  style = "font-family: 'Poppins';">OTP Has
                    Sent Successfully To Your Contact #</div>
                <h3  style = "font-family: 'Poppins';">Verify as {{ userName }}</h3>
                <form [formGroup]="otpCustomerData" (ngSubmit)="verifyCustomerOtp()">

                    <div class="row gx-2">

                        <div class="mb-3 col-sm-12">
                            <label class="form-label" for="card-mobile"  style = "font-family: 'Poppins';">Enter Contact OTP</label>
                            <input (keypress)="numberOnly($event)" class="form-control"
                                type="password" maxlength="6" formControlName="mobileotp"
                                autocomplete="new-password" id="card-mobile-otp" />
                        </div>
                        <p class="text-danger" *ngIf="otpErrorMessage"  style = "font-family: 'Poppins';">Invalid OTP!</p>
                    </div>


                    <div class="row flex-between-center">
                        <div class="col-auto rating p-0"></div>
                        <div class="col-auto text-center ">
                            <button class="btn btn-link fs--2" type="button"
                                (click)="customerLoginResendOtp()" [disabled]="messageSuccess"
                                style="border: none;">
                                <span  style = "font-family: 'Poppins';font-size: 10px;">Resend OTP</span>
                            </button>

                        </div>
                    </div>


                    <div class="mb-3 ">
                        <button class="btn btn-primary d-block w-100 mt-1 login-btn"  type="submit"
                            name="submit" style="height:40px;">
                            <span  style = "font-family: 'Poppins';">Verify</span>
                        </button>


                    </div>
                </form>

            </div>
        </div>

      </div>
      <div class="sign-right-container">
        <img src = "../../../../assets/img/dashboard-party-profiles/login-pic.png" class = "rightImage">
      </div>
    </div>
  </div>
</div>

















<!-- <main class="main" id="top">
    <div class="container-fluid">

        <div class="row min-vh-100 flex-center g-0">

            <div class="col-sm-12 col-md-12 col-lg-10 col-xl-8 col-xxl-7  py-3 position-relative">

                <div class="card overflow-hidden z-index-1">
                    <div class="card-body p-0">
                        <div class="row g-0 h-100">
                            <div class="col-sm-12 col-md-6 col-lg-6 bg-card-gradient">

                              <div class="position-relative pt-md-3 pb-md-7 light" style = "padding-top: 150px !important;">
                                <div class="z-index-1 position-relative p-4">

                                    <p class="mt-2 d-flex">
                                        <img src="assets/img/icons/spot-illustrations/Logo-2.png"
                                            alt="iceipts logo" width="40" height="40" style="position: absolute !important; top: -17% !important;left: 45%">
                                        <img src="assets/img/icons/spot-illustrations/Logo-1.png"
                                            alt="iceipts logo" width="130" height="20" style = "margin:auto;">
                                    </p>
                                    <br><br>
                                    <p class="opacity-75 text-white d-flex justify-content-center leftText">
                                        The technology that looks impossible today will<br>be part of our life
                                        tomorrow. Iceipts technology<br>creating difference.
                                    </p>

                                </div>
                              </div>

                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-6 form-box">

                                <div *ngIf="!Custtoggle" [hidden]="showClientOtp" class="demoRetailer">
                                    <button mat-flat-button style="color: #8692A6;" (click)="onCustomerClick()">
                                        <span style = "font-family: 'Poppins';">< Back</span>
                                      </button>
                                    <div class="signUpHeader pt-4 pb-3 flex-grow-1 hidden-scroll" style="max-height: 520px;">
                                        <div class="alert alert-warning border-2 d-flex align-items-center"
                                            *ngIf="showAlert" role="alert">
                                            <div class="bg-warning me-3 icon-item"><span
                                                    class="fas fa-exclamation-circle text-white fs-3"></span></div>
                                            <p class="mb-0 flex-1" style = "font-family: 'Poppins';">{{ errorMesage || 'Something went wrong please try again later !!!!'}}</p>
                                            <button class="btn-close" type="button" data-bs-dismiss="alert"
                                                aria-label="Close"></button>
                                        </div>
                                        <h1 style="font-weight: 500;margin: -13px 0 -2px;"><b class = "mb-1"  style = "font-size:20px;font-weight:500;font-family: 'Poppins';">Sign Up As a Retailer!</b></h1>
                                        <div class="toggle-text col-auto fs-0 mb-2 text-900"><span class="mb-0 undefined"  style = "font-family: 'Poppins';">
                                                Already have an Acccount? </span>
                                                <span><a style="color: #FC7643;"
                                                    (click)="onCustomerClick()"><u><b  style = "font-family: 'Poppins';"> LOGIN!</b></u></a></span>
                                                    <hr class="top-line my-2" style="opacity: 20%;">
                                        </div>
                                        <form [formGroup]="registerForm" (ngSubmit)="clientRegister()">

                                            <div class="mb-3 col-sm-12">
                                                <label class="form-label" for="card-firstname"  style = "font-family: 'Poppins';">Full Name <span class="error-asterisk">*</span></label>
                                                <input class="form-control" maxLength="50" placeholder="Full Name" autofocus
                                                    formControlName="firstName" type="text" [ngClass]="{
                                                     'is-invalid': f.firstName.invalid && submitted
                                                    }" autocomplete="new-password" id="card-firstname" required />
                                                <div style="margin-bottom: -10px;"
                                                    *ngIf="f.firstName.invalid && submitted"
                                                    class="invalid-feedback">
                                                    <div *ngIf="f.firstName.errors.required"  style = "font-family: 'Poppins';">
                                                        Firstname is required
                                                    </div>
                                                    <div *ngIf="f.firstName.errors.pattern"  style = "font-family: 'Poppins';">
                                                        Only characters allowed.
                                                    </div>
                                                </div>
                                            </div>


                                                <div class="mb-3 col-sm-12">
                                                    <label class="form-label" for="card-email"  style = "font-family: 'Poppins';">Email Address <span class="error-asterisk">*</span></label>
                                                    <input class="form-control" formControlName="email" type="text" placeholder="Email Address"
                                                        [ngClass]="{
                                                         'is-invalid': f.email.invalid && submitted
                                                        }" autocomplete="new-password" required id="card-email" />
                                                    <div style="margin-bottom: -10px;"
                                                        *ngIf="submitted && f.email.invalid" class="invalid-feedback">
                                                        <div *ngIf="f.email.errors.required"  style = "font-family: 'Poppins';">
                                                            Email is required
                                                        </div>
                                                        <div *ngIf="f.email.errors.pattern"  style = "font-family: 'Poppins';">
                                                            Email must be a valid Email address
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row gx-2">
                                                    <label class="form-label" for="card-mobile"  style = "font-family: 'Poppins';">Phone Number <span class="error-asterisk">*</span></label>
                                                    <div class="mb-3 col-sm-3">
                                                        <mat-form-field class="example-full-width" app>
                                                            <input type="text" class="form-control mod" (change)="getCountryByname($event)" aria-label="Assignee" matInput
                                                                formControlName="countryId" [matAutocomplete]="auto"
                                                                [ngClass]="{
                                                                  'is-invalid': f.countryId.invalid && submitted
                                                               }">
                                                            <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
                                                                <mat-option *ngFor="let option of filteredOptions | async" (onSelectionChange)="setCountryId(option)"
                                                                    [value]="option.countryNumber" matTooltip="{{ option.countryName }} {{option.countryNumber}}">
                                                                    {{option.countryName}}
                                                                    {{option.countryNumber}}
                                                                </mat-option>
                                                            </mat-autocomplete>
                                                            <div style="margin-bottom: -10px;" *ngIf="f.countryId.invalid && submitted" class="invalid-feedback mb-2">
                                                                <div *ngIf="f.countryId.errors.required"  style = "font-family: 'Poppins';">
                                                                    Country name is required.
                                                                </div>
                                                            </div>
                                                        </mat-form-field>
                                                    </div>

                                                    <div class="mb-3 col-sm-9">

                                                        <input class="form-control intl-tel-input" formControlName="mobile" type="tel" placeholder="Phone Number"
                                                            (keypress)="numberOnly($event)" minlength="9" maxlength="9"
                                                            [ngClass]="{ 'is-invalid': f.mobile.invalid && submitted }" autocomplete="new-password" id="card-mobile" />
                                                        <div style="margin-bottom: -10px;" *ngIf="f.mobile.invalid && submitted" class="invalid-feedback">
                                                            <div *ngIf="f.mobile.errors.required">
                                                                Mobile Number is required.
                                                            </div>

                                                            <div *ngIf="f.mobile.errors.minlength">
                                                                Mobile Number must be of 09-digits only
                                                            </div>
                                                            <div *ngIf="f.mobile.errors.maxlength">
                                                                Mobile Number must be of 09-digits only
                                                            </div>
                                                            <div *ngIf="f.mobile.errors.pattern">
                                                                Only Digits
                                                            </div>

                                                        </div>
                                                    </div>

                                                </div>

                                                <div class="mb-3 col-sm-12">
                                                    <label for="industryType" class="form-label">Industry Type <span class="error-asterisk">*</span></label>
                                                    <select class="form-select form-control" id="industryType" formControlName="industryType" name="industryType"
                                                    [ngClass]="{ 'is-invalid': f.industryType.invalid && submitted }" required>
                                                        <option value="Retail">Retail</option>
                                                        <option value="Supermarket">Supermarket</option>
                                                        <option value="Transporting">Transporting</option>
                                                        <option value="Spare Parts">Spare Parts</option>
                                                        <option value="Manufacturing">Manufacturing</option>
                                                    </select>
                                                    <div style="margin-bottom: -10px;" *ngIf="f.industryType.invalid && submitted" class="invalid-feedback">
                                                        <div *ngIf="f.industryType.errors.required && submitted" style = "font-family: 'Poppins';">
                                                            Industry type is required
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="mb-3  col-sm-12">
                                                    <label class="form-label" for="card-password"  style = "font-family: 'Poppins';">Create Password <span class="error-asterisk">*</span></label>
                                                    <input class="form-control mod" type="password"
                                                        [type]="hide ? 'password' : 'text'" formControlName="password"
                                                        id="card-password"
                                                        [ngClass]="{ 'is-invalid': f.password.invalid && submitted }"
                                                        required autocomplete="new-password" />
                                                    <span class="form-control-feedback" (click)="toggleShow()">
                                                        <i class="p-1"
                                                            [ngClass]="hide ? 'fa fa-eye-slash':'fa fa-eye'"></i>
                                                    </span>
                                                    <div style="margin-bottom: -10px;"
                                                        *ngIf="f.password.invalid && submitted"
                                                        class="invalid-feedback">
                                                        <div *ngIf="f.password.errors.required"  style = "font-family: 'Poppins';">
                                                            Password is required.
                                                        </div>
                                                    </div>

                                                </div>

                                            <div class="form-check my-2">
                                                <input class="form-check-input" type="checkbox"
                                                    id="card-register-checkbox" formControlName="acceptTerms" [ngClass]="{
                                                    'is-invalid': f.acceptTerms.invalid && submitted
                                                    }" required />
                                                <label class="form-label" for="card-register-checkbox"  style = "font-family: 'Poppins';">I agree to
                                                    <a routerLink="/auth/term-and-condition"><u  style = "font-family: 'Poppins';"> Terms & Condition
                                                        </u></a> </label>
                                                <div style="margin-bottom: -13px;"
                                                    *ngIf="submitted && f.acceptTerms.errors" class="invalid-feedback"  style = "font-family: 'Poppins';">
                                                    Accept Ts & Cs is required
                                                </div>
                                            </div>
                                            <div class="mb-1">
                                                <button  class="login-btn d-block w-100 mt-3" type="submit"
                                                    name="submit">
                                                    <span  style = "font-family: 'Poppins';">Register</span>
                                                </button>
                                            </div>

                                        </form>


                                    </div>
                                </div>

                                <div *ngIf="Custtoggle" [hidden]="showCustomerOtp" class="demo">
                                    <button mat-flat-button style="color: #8692A6;" (click)="onRetailerClick()">
                                        <span  style = "font-family: 'Poppins';">< Back</span>
                                      </button>

                                    <div class="p-4 p-md-5 flex-grow-1">
                                        <div class="alert alert-warning border-2 d-flex align-items-center"
                                            *ngIf="showAlert" role="alert">
                                            <div class="bg-warning me-3 icon-item"><span
                                                    class="fas fa-exclamation-circle text-white fs-3"></span></div>
                                            <p class="mb-0 flex-1"  style = "font-family: 'Poppins';">User Exists Already!!!!</p>
                                            <button class="btn-close" type="button" data-bs-dismiss="alert"
                                                aria-label="Close"></button>
                                        </div>
                                        <h1 style="font-weight: 500;color: #000000;font-family: 'Poppins';font-size:20px;">Sign Up As a Customer!</h1>
                                        <div class="toggle-text col-auto fs-0 my-3 text-900">
                                            <span class="mb-0 undefined"  style = "font-family: 'Poppins';">
                                                Already have an account?
                                            </span>
                                            <span><a style="color: #FC7643;" (click)="onRetailerClick()">
                                                <b  style = "font-family: 'Poppins';">LOGIN!</b></a>
                                                </span>
                                                <hr class="top-line my-2" style="opacity: 20%;">
                                        </div>
                                        <form [formGroup]="customerRegisterForm" (ngSubmit)="customerRegister()">

                                            <div class="mb-3 col-sm-12">
                                                <label class="form-label" for="card-firstname"  style = "font-family: 'Poppins';">Full Name</label>
                                                <input class="form-control" maxLength="15" placeholder="Full name"
                                                    formControlName="firstName" type="text" [ngClass]="{
                                                     'is-invalid': c.firstName.invalid && submitted
                                                     }" autocomplete="new-password" id="card-firstname" required />
                                                <div *ngIf="c.firstName.invalid && submitted"
                                                    class="invalid-feedback">
                                                    <div *ngIf="c.firstName.errors.required"  style = "font-family: 'Poppins';">
                                                        Firstname is required
                                                    </div>
                                                    <div *ngIf="c.firstName.errors.pattern"  style = "font-family: 'Poppins';">
                                                        Only characters allowed.
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row gx-2">
                                                <label class="form-label" for="card-mobile"  style = "font-family: 'Poppins';">Phone Number</label>
                                                <div class="mb-3 col-sm-3">
                                                    <mat-form-field class="example-full-width" app>
                                                        <input type="text" class="form-control mod" (change)="getCountryByname($event)" aria-label="Assignee" matInput
                                                            formControlName="countryId" [matAutocomplete]="auto" [ngClass]="{
                                                                                                                        'is-invalid': f.countryId.invalid && submitted
                                                                                                                        }">
                                                        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
                                                            <mat-option *ngFor="let option of filteredOptions | async" (onSelectionChange)="setCountryId(option)"
                                                                [value]="option.countryName" matTooltip="{{ option.countryName }} {{option.countryNumber}}">
                                                                {{option.countryName}} {{option.countryNumber}}
                                                            </mat-option>
                                                        </mat-autocomplete>
                                                        <div style="margin-bottom: -10px;" *ngIf="f.countryId.invalid && submitted" class="invalid-feedback mb-2">
                                                            <div *ngIf="f.countryId.errors.required"  style = "font-family: 'Poppins';">
                                                                Country name is required.
                                                            </div>
                                                        </div>
                                                    </mat-form-field>
                                                </div>

                                                <div class="mb-3 col-sm-9">

                                                    <input class="form-control intl-tel-input" formControlName="mobile" type="tel" placeholder="Phone Number"
                                                        (keypress)="numberOnly($event)" minlength="9" maxlength="9"
                                                        [ngClass]="{ 'is-invalid': f.mobile.invalid && submitted }" autocomplete="new-password" id="card-mobile" />
                                                    <div style="margin-bottom: -10px;" *ngIf="f.mobile.invalid && submitted" class="invalid-feedback">
                                                        <div *ngIf="f.mobile.errors.required">
                                                            Mobile Number is required.
                                                        </div>

                                                        <div *ngIf="f.mobile.errors.minlength">
                                                            Mobile Number must be of 09-digits only
                                                        </div>
                                                        <div *ngIf="f.mobile.errors.maxlength">
                                                            Mobile Number must be of 09-digits only
                                                        </div>
                                                        <div *ngIf="f.mobile.errors.pattern">
                                                            Only Digits
                                                        </div>

                                                    </div>
                                                </div>

                                            </div>

                                            <div class="form-check">
                                                <input class="form-check-input" type="checkbox" (keyup.enter)="customerRegister()"
                                                    id="card-register-checkbox" formControlName="acceptTerms" [ngClass]="{
                                                 'is-invalid': c.acceptTerms.invalid && submitted
                                                 }" required />
                                                <label class="form-label" for="card-register-checkbox"  style = "font-family: 'Poppins';">I agree to
                                                    <a routerLink="/auth/term-and-condition"><u  style = "font-family: 'Poppins';"> Terms & Condition
                                                        </u></a>
                                                </label>
                                                <div *ngIf="submitted && c.acceptTerms.errors" class="invalid-feedback"  style = "font-family: 'Poppins';">
                                                    Accept Ts & Cs is required
                                                </div>
                                            </div>
                                            <div class="form-check">

                                            </div>
                                            <div class="mb-1">
                                                <button class="login-btn d-block w-100 mt-0" type="submit"
                                                    name="submit">
                                                    <span  style = "font-family: 'Poppins';">Register</span>
                                                </button>
                                            </div>
                                        </form>

                                    </div>
                                </div>

                                <div [hidden]="!showClientOtp" class = "demo">
                                    <div class="p-4 p-md-5 flex-grow-1">
                                        <div class="alert alert-success mb-5" *ngIf="successful" role="alert"  style = "font-family: 'Poppins';">OTP Has
                                            Sent Successfully To Your Email-ID And Mobile Number</div>
                                        <h3  style = "font-family: 'Poppins';">Verify as {{ userName }}</h3>
                                        <form [formGroup]="otpClientData" (ngSubmit)="verifyClientOtp()">

                                            <div class="row gx-2">
                                                <div class="mb-3 col-sm-12">
                                                    <label class="form-label" for="card-email"  style = "font-family: 'Poppins';">Enter Email OTP</label>
                                                    <input class="form-control" (keypress)="numberOnly($event)"
                                                        formControlName="emailotp" type="password" id="card-email-otp" />
                                                </div>
                                            </div>
                                            <div class="row flex-between-center">
                                                <div class="col-auto"></div>
                                                <div class="col-auto text-center">
                                                    <button class="btn btn-link fs--2" (click)="clientResendOtp()"
                                                        type="button" [disabled]="messageSuccess" style="border: none;">
                                                        <span  style = "font-family: 'Poppins';font-size: 10px;">Resend OTP</span>
                                                    </button>
                                                </div>
                                            </div>
                                            <div class="mb-3">
                                                <button class="btn login-btn d-block w-100 mt-3" type="submit"
                                                    name="submit">
                                                    <span  style = "font-family: 'Poppins';">Verify</span>
                                                </button>

                                            </div>
                                        </form>

                                    </div>
                                </div>

                                <div [hidden]="!showCustomerOtp" class = "demo">
                                    <div class="p-4 p-md-5 flex-grow-1">
                                        <div class="alert alert-success mb-5" *ngIf="successful" role="alert"  style = "font-family: 'Poppins';">OTP Has
                                            Sent Successfully To Your Mobile Number</div>
                                        <h3  style = "font-family: 'Poppins';">Verify as {{ userName }}</h3>
                                        <form [formGroup]="otpCustomerData" (ngSubmit)="verifyCustomerOtp()">

                                            <div class="row gx-2">

                                                <div class="mb-3 col-sm-12">
                                                    <label class="form-label" for="card-mobile"  style = "font-family: 'Poppins';">Enter Mobile OTP</label>
                                                    <input (keypress)="numberOnly($event)" class="form-control"
                                                        type="password" maxlength="6" formControlName="mobileotp"
                                                        autocomplete="new-password" id="card-mobile-otp" />
                                                </div>
                                                <p class="text-danger" *ngIf="otpErrorMessage"  style = "font-family: 'Poppins';">Invalid OTP!</p>
                                            </div>


                                            <div class="row flex-between-center">
                                                <div class="col-auto rating p-0"></div>
                                                <div class="col-auto text-center ">
                                                    <button class="btn btn-link fs--2" type="button"
                                                        (click)="customerLoginResendOtp()" [disabled]="messageSuccess"
                                                        style="border: none;">
                                                        <span  style = "font-family: 'Poppins';font-size: 10px;">Resend OTP</span>
                                                    </button>

                                                </div>
                                            </div>


                                            <div class="mb-3 ">
                                                <button class="btn btn-primary d-block w-100 mt-1 login-btn"  type="submit"
                                                    name="submit">
                                                    <span  style = "font-family: 'Poppins';">Verify</span>
                                                </button>


                                            </div>
                                        </form>

                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</main> -->
